<template>
  <div>
    <h1>AUFBAU UND FUNKTION</h1>
    
    <p>
      Beispieltext
    </p>
  </div>
  
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {
  background-color: brown;
}
img {
  width: 600px;
  height: 900px;
  object-fit: contain;
  
  
}
h1 {
  font-size: 300%;
  padding-top: 30px;

  
}
h2 {
  font-size: 250%;
  padding: 10px;
}
h3 {
  text-align: left;
  padding-left: 250px;
  font-size: 150%;
  
}
ul{
  text-align: left;
  padding-left: 250px;
}
p {
  text-align: left;
  padding-left: 250px;
}
</style>